module.exports = __webpack_public_path__ + "media/images/bh-logo-8ec83308605befd9a5bb9b335b072c19.svg";